import { createContext } from 'react';

import { func } from '@utils';

import { TopBarContextPair } from './TopBar.types';
import { TOP_BAR_CTX_VALUE } from './TopBar.const';

export const TopBarContext = createContext<TopBarContextPair>([TOP_BAR_CTX_VALUE, func.nop]);
